<template>
  <layout-default-appbar :back-to="false">
    <div class="d-flex align-center custom-header">
      <v-btn icon @click="voltar" class="mr-2">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <span class="pl-2 text-h6">{{ tituloAppBar }}</span>
    </div>
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewOrcamentoCadastroAppBar',

  components: {
    LayoutDefaultAppbar,
  },
  
  data() {
    return {
      tituloAppBar: 'Cadastro Coleta' 
    };
  },

  methods: {
    voltar() {
      this.$root.$emit('appbar-solicita-cancelamento');
    }
  }
};
</script>,


<style scoped>

::v-deep .v-app-bar__nav-icon {
  display: none !important;
}

::v-deep button.v-app-bar__nav-icon {
  display: none !important;
}

.custom-header {
  margin-left: -30px;
}

</style>